/**
 * MemberFooter — thin footer used inside authenticated app pages. Complements
 * the marketing footer on the public landing page. Surfaces the legal links,
 * help center, service status, and a quick bug report trigger so no matter
 * where users are they can always reach these.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, ExternalLink } from 'lucide-react';

const STATUS_PAGE_URL = 'https://status.freezedry.academy';

const MemberFooter = () => (
  <footer
    className="mt-16 border-t border-border bg-muted/30"
    data-testid="member-footer"
  >
    <div className="container mx-auto px-6 py-6 flex flex-col md:flex-row items-center gap-3 justify-between text-xs text-muted-foreground">
      <div className="flex items-center gap-2 text-[11px]">
        <span>© {new Date().getFullYear()} Freeze Dry Academy</span>
        <span aria-hidden>·</span>
        <span>Made for serious operators</span>
      </div>

      <nav className="flex flex-wrap items-center gap-x-4 gap-y-1">
        <Link to="/help" className="hover:text-foreground font-semibold" data-testid="footer-help">Help center</Link>
        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent('fda:open-report', { detail: { type: 'bug' } }))}
          className="hover:text-foreground font-semibold"
          data-testid="footer-report-bug"
        >
          Report a bug
        </button>
        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent('fda:open-report', { detail: { type: 'support' } }))}
          className="hover:text-foreground font-semibold"
          data-testid="footer-contact-support"
        >
          Contact support
        </button>
        <Link to="/community-standards" className="hover:text-foreground font-semibold" data-testid="footer-standards">
          Community Standards
        </Link>
        <Link to="/terms" className="hover:text-foreground font-semibold" data-testid="footer-terms">
          Terms of Use
        </Link>
        <a
          href={STATUS_PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground font-semibold inline-flex items-center gap-1"
          data-testid="footer-status"
        >
          <Activity className="w-3 h-3" /> Status
          <ExternalLink className="w-2.5 h-2.5 opacity-60" />
        </a>
      </nav>
    </div>
  </footer>
);

export default MemberFooter;
